import {
    GET_PLAYER,
    GET_PLAYER_SUCCESS,
    GET_PLAYER_FAILED,
    GET_DETAILED_CAMPAIGN,
    GET_DETAILED_CAMPAIGN_SUCCESS,
    GET_DETAILED_CAMPAIGN_FAILED,
    GET_PLAYER_LIST,
    GET_PLAYER_LIST_SUCCESS,
    GET_PLAYER_LIST_FAILED
} from './actionTypes';


const initialState = {
    error: "",
    loading: false,
    screens: undefined,
    campaigns: undefined,
    detailed_campaigns: undefined,
    disabled_count: undefined,
    playerList: undefined,
}

const screen = (state = initialState, action) => {
    switch (action.type) {
        case GET_PLAYER:
            state = {
                ...state,
                loading: true
            }
            break;
        case GET_PLAYER_SUCCESS:
            state = {
                ...state,
                loading: false,
                screens: action.payload.screens && JSON.parse(action.payload.screens),
                campaigns: action.payload.campaigns && JSON.parse(action.payload.campaigns),
                disabled_count: action.payload.disabled_count
            }
            break;
        case GET_PLAYER_FAILED:
            state = {
                ...state,
                loading: false
            };
            break;

        case GET_PLAYER_LIST:
            state = {
                ...state,
                loading: true
            }
            break;
        case GET_PLAYER_LIST_SUCCESS:
            state = {
                ...state,
                loading: false,
                playerList: action.payload
            }
            break;
        case GET_PLAYER_LIST_FAILED:
            state = {
                ...state,
                loading: false
            };
            break;

        case GET_DETAILED_CAMPAIGN:
            state = {
                ...state,
                loading: true
            }
            break;
        case GET_DETAILED_CAMPAIGN_SUCCESS:
            state = {
                ...state,
                loading: false,
                detailed_campaigns: action.payload
            }
            break;
        case GET_DETAILED_CAMPAIGN_FAILED:
            state = {
                ...state,
                loading: false
            };
            break;
        default:
            state = { ...state };
            break;
    }
    return state;
}

export default screen;